<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <!-- <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-input v-model="name" placeholder="请输入姓名/单号/手机号" style="width:250px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectorderbynameBtn">搜索</el-button>
      </el-form-item>
    </el-form>-->
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="orderArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{background:'#e8effc', color:'#000'}"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <!-- <el-table-column label="订单id">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{scope.row.id }}</span>
          </template>
        </el-table-column>-->
        
        <el-table-column label="分享者手机号" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.shareUserPhone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="入驻用户手机号" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userPhone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="分享者奖励" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.reward}}（元）</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button size="mini" @click="ejectupdataGoods(scope.row)">订单详情</el-button>
            <el-button size="mini" type="danger" @click="deleteUser(scope.row)">删除</el-button>
          </template>
        </el-table-column>-->
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="pageCount"
      ></el-pagination>-->
    </div>
    <!-- 订单详情 -->
    <el-dialog title="订单详情与发货" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <!-- <el-form-item label="商品名称" :label-width="formLabelWidth">
          <el-input v-model="form.teaTitle" auto-complete="off"></el-input>
        </el-form-item>
        -->
        <el-form-item label="请输入物流单号">
          <el-input v-model="expressNumber" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="updataBtn">确定发货</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { seleteshareByid } from "@/services/vipCard";
export default {
  data() {
    return {
      orderArr: [],
      loading: true,
      name: "",
      expressNumber: "",
      form: "",
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false
    };
  },
  created() {
    // 查询分享记录 不传id查所有
    seleteshareByid(0).then(res => {
      console.log(res);
      this.orderArr = res.data;
      this.loading = false;
    });
  },
  methods: {
    select() {
      // 查询订单数据
      seleteshareByid(0).then(res => {
        console.log(res);
        this.orderArr = res.data;
        this.loading = false;
      });
    },

    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
    },
    handleCurrentChange(e) {
      console.log("当前页：", e);
      this.select(e);
    },
    prevClick(e) {
      console.log("上一页:", e);
      this.select(e);
    },
    nextClick(e) {
      console.log("下一页:", e);
      this.selectAll(e);
    }
  }
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>